<template>
  <b-row class="block__profile block__profile-info" >

    <!-- ENTETE -->
    <div class="mobile">
      <div class="wrapper">
        <div class="link">
          <button class="bt btn-back" @click="goBack()">
              <font-awesome-icon :icon="['far', 'angle-left']"/>
          </button>
          <h3>{{general.profileTitle}}</h3>
        </div>
          
        <button class="bt bt-blue btn-save">
            {{general.formBtSave}}
        </button>      
      </div>
      <div class="sep"></div>
    </div>
    <!-- ENTETE -->



    <div class="scrollable extend-lg col">
      <h1>{{general.profileTitleInfoPerso}}</h1>

      <b-form-group
        id="input-group-1"
        :label="general.profileFormLabel.name"
        label-for="inputs-1"
        description=""
      >
        <b-form-input
          id="inputs-1"
          v-model="form.name"
          type="text"
          required
          :placeholder="placeholder.name"
        ></b-form-input>
      </b-form-group>


      <b-form-group
        id="input-group-2"
        :label="general.profileFormLabel.firstname"
        label-for="inputs-2"
        description=""
      >
        <b-form-input
          id="inputs-2"
          v-model="form.firstname"
          type="text"
          required
          :placeholder="placeholder.firstname"
        ></b-form-input>
      </b-form-group>


      <b-form-group
        id="input-group-3"
        :label="general.profileFormLabel.email"
        label-for="inputs-3"
        description=""
      >
        <b-form-input
          id="inputs-3"
          v-model="form.email"
          type="email"
          required
          :placeholder="placeholder.email"
        ></b-form-input>
      </b-form-group>




      <!-- //////////////////////////////////
      ///////////////////////////////////
      //////////////////////////////////// -->
      <h1>{{general.profileTitleInfoAgence}}</h1>


      <b-form-group
        id="input-group-4"
        :label="general.profileFormLabel.codeAgence"
        label-for="inputs-4"
        description=""
      >
        <b-form-input
          id="inputs-4"
          v-model="form.codeAgence"
          type="text"
          required
          :placeholder="placeholder.email"
        ></b-form-input>
      </b-form-group>


      <b-form-group
        id="input-group-5"
        :label="general.profileFormLabel.adresse1"
        label-for="inputs-5"
        description=""
      >
        <b-form-input
          id="inputs-5"
          v-model="form.adresse1"
          type="text"
          required
          :placeholder="placeholder.adresse1"
        ></b-form-input>
      </b-form-group>


      <b-form-group
        id="input-group-6"
        :label="general.profileFormLabel.adresse2"
        label-for="inputs-6"
        description=""
      >
        <b-form-input
          id="inputs-6"
          v-model="form.adresse2"
          type="text"
          required
          :placeholder="placeholder.adresse2"
        ></b-form-input>
      </b-form-group>

      <b-form-group
        id="input-group-7"
        :label="general.profileFormLabel.city"
        label-for="inputs-7"
        description=""
      >
        <b-form-input
          id="inputs-7"
          v-model="form.city"
          type="text"
          required
          :placeholder="placeholder.city"
        ></b-form-input>
      </b-form-group>

      <b-form-group
        id="input-group-8"
        :label="general.profileFormLabel.postalCode"
        label-for="inputs-8"
        description=""
      >
        <b-form-input
          id="inputs-8"
          v-model="form.postal"
          type="text"
          required
          :placeholder="placeholder.postal"
        ></b-form-input>
      </b-form-group>

      <b-form-group
        id="input-group-9"
        :label="general.profileFormLabel.region"
        label-for="inputs-9"
        description=""
      >
        <b-form-input
          id="inputs-9"
          v-model="form.region"
          type="text"
          required
          :placeholder="placeholder.region"
        ></b-form-input>
      </b-form-group>

      <!-- ////////////////////////////////////////////
      //////////////////////////////////////////////
      /////////////////////////////////////////////// -->
      <h1>{{general.profileTitleInfoMdp}}</h1>

      <b-form-group
        id="input-group-10"
        :label="general.profileFormLabel.mdp"
        label-for="inputs-10"
        description=""
      >
        <b-form-input
          id="inputs-10"
          v-model="form.mdp"
          type="password"
          required
          :placeholder="placeholder.mdp"
        ></b-form-input>
      </b-form-group>

      <b-form-group
        id="input-group-11"
        :label="general.profileFormLabel.mdpConfirm"
        label-for="input-11"
        description=""
      >
        <b-form-input
          id="input-11"
          v-model="form.mdp"
          type="password"
          required
          :placeholder="placeholder.mdp"
        ></b-form-input>
      </b-form-group>

        <button class="bt bt-blue btn-save">
            {{general.formBtSave}}
        </button>  
        
    </div>

  </b-row>
</template>




<script>
import { mapGetters } from 'vuex'


export default {
  name:"profileInfo",
    components:{
    }, 
    computed: {
      ...mapGetters([
        'getGeneral',
        'getInitial'
      ])
    },
    data () {
      return {
        general:"",
        isLoading:true,
        form:{
          name:'',
        },
        placeholder:{
          name:'Cers',
          firstname:'Pierre',
          email:'email@agence.com',
          codeAgence:'Agence ccsa Sarl',
          adresse1:'15 allée des cocottes',
          adresse2:'',
          city:'Bordeaux',
          codePostal:'33000',
          region:'Quebec',
          mdp:'motdepasse'
        }       
      }
    },
    created (){
      this.general = this.getGeneral;
      this.initial = this.getInitial;

    // setTimeout(() => {
    //     this.isLoading = false;
    //   },2000)         
    },    
    methods : {
      goBack() {
        this.$router.push({name: "profileHome"});  
      },       
    }
};
</script>
